import { ContactLinkCategory } from './contactLinkCategory';

export enum ContactType {
  PHONE = 'PHONE',
  EMAIL = 'EMAIL',
  LINK = 'LINK',
  ADDRESS = 'ADDRESS',
  MESSENGER = 'MESSENGER',
}

export interface ContactBase {
  id?: string;
  type: ContactType;
}

export interface PhoneContact extends ContactBase {
  type: ContactType.PHONE;
  phoneNumber: string;
}

export interface EmailContact extends ContactBase {
  type: ContactType.EMAIL;
  email: string;
}

export interface LinkContact extends ContactBase {
  type: ContactType.LINK;
  url: string;
  category?: Pick<ContactLinkCategory, 'id' | 'name'> | { id: string };
}

export interface AddressContact extends ContactBase {
  type: ContactType.ADDRESS;
  country?: string;
  city?: string;
  addressLine1?: string;
  addressLine2?: string;
  postalCode?: string;
}

export interface MessengerContact extends ContactBase {
  type: ContactType.MESSENGER;
  name: string; // messenger name
  username: string;
}

export type Contact =
  | PhoneContact
  | EmailContact
  | LinkContact
  | AddressContact
  | MessengerContact;

export type ContactShort = Required<Pick<ContactBase, 'id' | 'type'>> & Partial<PhoneContact & EmailContact & LinkContact & AddressContact & MessengerContact>;
